import type { EmptyStateActionsProps } from "./empty-state.types";

import styles from "./empty-state-wrapper.module.css";

export function EmptyStateWrapper({
  children,
  className = "",
  ...props
}: EmptyStateActionsProps) {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
}
